import { Skeleton } from '@mui/material';
import React from 'react';

function ContractSkeleton() {
  return (
    <>
      <Skeleton sx={{ m: 2 }} variant="rectangular" width="25%" height="25" />
      <Skeleton sx={{ m: 2 }} variant="rectangular" width="95%" height="25" />
      <Skeleton sx={{ m: 2 }} variant="rectangular" width="50%" height="25" />
      <Skeleton sx={{ m: 2 }} variant="rectangular" width="95%" height="85vh" />
    </>
  );
}

export default ContractSkeleton;
